<template>
  <div class="modal fade" id="pollModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" :class="{'modal-dialog-centered' : active != 'new'}">
      <button type="button" class="btn-close text-start d-none" data-bs-dismiss="modal" id="pollModalCloseBTN"></button>

      <div class="modal-content" v-if="active == 'new'">
        <div class="modal-body">
          <div class="alert alert-secondary">
            <h5 class="text-center" style="font-size:18px">سفارشت چطور بود؟</h5>
            <h5 class="text-center mt-1" style="font-size:18px">نظرت برامون ارزشمنده</h5>
          </div>          
          <form required>
              <div class="item-star">
                <small class="d-block text-center mt-1">به سفارشت چند ستاره میدی؟</small>
                <div class="text-center mt-2">
                  <i class="fa fa-2x fa-star mr-1" :style="{ color: hole.five.color }" aria-hidden="true" @click="addStar(5)"></i>
                  <i class="fa fa-2x fa-star mr-1" :style="{ color: hole.four.color }" aria-hidden="true" @click="addStar(4)"></i>
                  <i class="fa fa-2x fa-star mr-1" :style="{ color: hole.three.color }" aria-hidden="true" @click="addStar(3)"></i>
                  <i class="fa fa-2x fa-star mr-1" :style="{ color: hole.two.color }" aria-hidden="true" @click="addStar(2)"></i>
                  <i class="fa fa-2x fa-star mr-1" :style="{ color: hole.one.color }" aria-hidden="true" @click="addStar(1)"></i>
                </div>

              <div class="text-center mt-2" :class="{'visible':starText,'invisible':!starText }"><span class="px-1 bg-light rounded">{{ starText }}</span></div>
            </div>
            <div class="item-assessment mt-2">
              <h5 class="text-center ">بنظرت هر قسمت چطور بود؟</h5>
              <div class="assessment-plan mb-1">
                <div class="mb-3 mt-3 d-flex justify-content-between">
                  <label>خدمات</label>
                  <div>
                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="servicesRadioBTN" value="1">
                      <label class="form-check-label" for="servicesRadioBTN">
                        خوب
                      </label>
                    </div>

                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="servicesRadioBTN" value="2">
                      <label class="form-check-label" for="servicesRadioBTN">
                        متوسط
                      </label>
                    </div>

                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="servicesRadioBTN" value="3">
                      <label class="form-check-label" for="servicesRadioBTN">
                        ضعیف
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="assessment-plan mb-1">
                <div class="mb-3 mt-3 d-flex justify-content-between">
                  <label>پیک</label>
                  <div>
                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="peykRadioBTN" value="1">
                      <label class="form-check-label" for="peykRadioBTN">
                        خوب
                      </label>
                    </div>

                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="peykRadioBTN" value="2">
                      <label class="form-check-label" for="peykRadioBTN">
                        متوسط
                      </label>
                    </div>

                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="peykRadioBTN" value="3">
                      <label class="form-check-label" for="peykRadioBTN">
                        ضعیف
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="assessment-plan mb-1">
                <div class="mb-3 mt-3 d-flex justify-content-between">
                  <label>بسته بندی</label>
                  <div>
                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="pakingRadioBTN" value="1">
                      <label class="form-check-label" for="pakingRadioBTN">
                        خوب
                      </label>
                    </div>

                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="pakingRadioBTN" value="2">
                      <label class="form-check-label" for="pakingRadioBTN">
                        متوسط
                      </label>
                    </div>

                    <div class="form-check d-inline-block">
                      <input class="form-check-input" type="radio" name="pakingRadioBTN" value="3">
                      <label class="form-check-label" for="pakingRadioBTN">
                        ضعیف
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-present mt-2">
              <div>
                <textarea class="form-control" id="presentInput" rows="3"
                  placeholder="احساس رضایت یا عدم رضایت یا پیشنهاد خودت رو با ما در میون بذار ..."></textarea>
              </div>
            </div>
            <div class="item-btn mt-3 text-start">
              <button v-if="!finallFlag" type="submit" class="btn btn-success w-100" @click="submitPoll($event)">ثبت نظر</button>
              <button v-if="finallFlag" class="btn btn-success w-100 " disabled>
                    <div class="spinner-border text-light" role="status" style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    لطفا شکیبا باشید
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-content" v-if="active == 'exist'">
        <h6 class="text-center p-4" style="font-weight: 600;color:#06084b">شما قبلا در این نظر سنجی شرکت کرده اید.</h6>
        <button @click="goHome" class="btn btn-success w-50 mx-auto mb-2" >متوجه شدم</button>

      </div>
        <Transition name="bounce">
          <div class="modal-content"  v-if="active == 'complete' && show" >
              <p class="text-center pt-3 p-2 h5 rounded" style="color: #b93131;font-weight: 600;">{{ convertToPersian(String(30))}} امتیاز بدست آوردید. </p>
              <button @click="goHome" class="btn btn-light w-50 mx-auto mb-2" style="border-color: rgb(0 0 0 / 40%)">متوجه شدم</button>
          </div>
        </Transition>
      <div class="modal-content" v-if="active == ''" >
        <h6 class="text-center p-4" style="font-weight: 600;">لطفا چند لحظه صبر کنید...</h6>
      </div>
    </div>

  </div>
</template>
<script setup>
import { reactive, ref,computed,watch } from 'vue';
import { useRoute,useRouter } from 'vue-router';
import { convertToPersian } from '@/composables/digits';
import { alertBox } from '@/composables/silverBox';
let route = useRoute();
let router = useRouter();
let starColor = reactive({
  one : '#c13024',
  two : '#c47617',
  three : '#d59916',
  four : '#d0c111',
  five : '#dffc45'
});
let finallColor = ref('#e7e732');
let starText = ref('');
let pre_id = ref()
let state = ref()
let finallFlag = ref(false)
let show = ref(false)
// let tooltipText = ref(null)
let active = ref('')
let loadingFlag = ref(false)
let poll = reactive({
  star: 'a0',
  service: [0, 0, 0],
  present: ''
});
let hole = reactive({
  one: { 'color': starColor.one, 'value': 'خیلی بد' },
  two: { 'color': starColor.two, 'value': 'بد' },
  three: { 'color': starColor.three, 'value': 'متوسط' },
  four: { 'color': starColor.four, 'value': 'خوب' },
  five: { 'color': starColor.five, 'value': 'عالی' }
})
const page = computed(() => route.name);

watch(page, async () => {
  if(route.name == 'Poll'){
    await getState();
  }else{
    if(document.getElementById('pollModalCloseBTN')){
      document.getElementById('pollModalCloseBTN').click()
    }
  }
}, { immediate: true });

async function getState() {
    let response = await fetch('https://radap.ir/Backend/api/section/survay/getState.php?pre_id=' + route.params.id)
    let data = await response.json()
        pre_id.value = data.pre_id;
        state.value = data.state;
        if (state.value > 1) {
          active.value = 'exist'
        } else {
          active.value = 'new'
        }
}
async function submitPoll(e) {
  finallFlag.value = true
  e.preventDefault()
  if (document.querySelector('input[name="servicesRadioBTN"]:checked') != null) {
    poll.service[0] = document.querySelector('input[name="servicesRadioBTN"]:checked').value
  } else {
    poll.service[0] = 'a0'
  }
  if (document.querySelector('input[name="peykRadioBTN"]:checked') != null) {
    poll.service[1] = document.querySelector('input[name="peykRadioBTN"]:checked').value
  } else {
    poll.service[1] = 'a0'
  }
  if (document.querySelector('input[name="pakingRadioBTN"]:checked') != null) {
    poll.service[2] = document.querySelector('input[name="pakingRadioBTN"]:checked').value
  } else {
    poll.service[2] = 'a0'
  }
  if (document.getElementById('presentInput').value != '') {
    poll.present = document.getElementById('presentInput').value
  } else {
    poll.present = 'a-'
  }

  let response = await fetch('https://radap.ir/Backend/api/section/survay/set.php?pre_id=' + pre_id.value + '&star=' + poll.star + '&service=' + poll.service + '&present=' + poll.present)
  let data = await response.text()
  console.log(data);
      if(data == 'null'){
        finallFlag.value = false
        if(poll.star == 'a0'){
          alertBox('لطفا به خریدتان ستاره بدهید');
        }else{
          alertBox('لطفا حداقل یک مورد را انتخاب نمایید');
        }
      }else{
        active.value = 'complete'
        show.value = true
      }
}
function addStar(several) {
  staring(several)
  poll.star = several;
}
function staring(several) {
  hole.one.color = "rgb(120 120 120)";
  hole.two.color = "rgb(120 120 120)";
  hole.three.color = "rgb(120 120 120)";
  hole.four.color = "rgb(120 120 120)";
  hole.five.color = "rgb(120 120 120)";
  starText.value = '';
  switch (several) {
    case 1:
      hole.one.color = finallColor.value;
      starText.value = hole.one.value;
      break;
    case 2:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      starText.value = hole.two.value;
      break;
    case 3:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      hole.three.color = finallColor.value;
      starText.value = hole.three.value;
      break;
    case 4:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      hole.three.color = finallColor.value;
      hole.four.color = finallColor.value;
      starText.value = hole.four.value;
      break;
    case 5:
      hole.one.color = finallColor.value;
      hole.two.color = finallColor.value;
      hole.three.color = finallColor.value;
      hole.four.color = finallColor.value;
      hole.five.color = finallColor.value;
      starText.value = hole.five.value;
      break;
    default:
      break;
  }
}
function goHome(){
  document.getElementById('pollModalCloseBTN').click()
  router.push('/')
}
</script>

<style scoped>

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>
